var _path, _rect, _rect2, _rect3, _rect4, _path2, _line, _circle, _line2, _ellipse, _line3, _circle2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconNeedsAssessment = function SvgIconNeedsAssessment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 189,
    viewBox: "0 0 153 189",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M76.0774 150.967C118.094 150.967 152.155 117.172 152.155 75.4834C152.155 33.7951 118.094 0 76.0774 0C34.061 0 0 33.7951 0 75.4834C0 117.172 34.061 150.967 76.0774 150.967Z",
    fill: "#CCE2F1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44.3538,
    y: 32.4936,
    width: 28.0537,
    height: 28.0537,
    rx: 14.0269,
    stroke: "#006FBA",
    strokeWidth: 4.63953
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.31977,
    y: 44.1713,
    width: 112.122,
    height: 142.48,
    rx: 7.02116,
    fill: "#B0E8FB",
    stroke: "#006FBA",
    strokeWidth: 4.63953
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.331,
    y: 53.5131,
    width: 84.0993,
    height: 119.128,
    rx: 7.02116,
    fill: "#00BFFF",
    stroke: "#006FBA",
    strokeWidth: 4.63953
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28.0073,
    y: 44.1713,
    width: 60.747,
    height: 18.7128,
    rx: 7.02116,
    fill: "#B0E8FB",
    stroke: "#006FBA",
    strokeWidth: 4.63953
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3345 101.798C52.3345 103.755 53.8918 105.152 55.7686 105.152C57.6455 105.152 59.2428 103.755 59.2428 101.798C59.2428 99.8813 57.6455 98.4837 55.7686 98.4837C53.8918 98.4837 52.3345 99.8813 52.3345 101.798ZM49.659 81.9117C49.1399 83.1896 49.4993 84.9865 50.8969 85.5855C52.2945 86.1845 54.3311 85.5456 54.7703 84.2677C55.2495 82.91 56.2878 82.351 57.4857 82.351C59.1629 82.351 60.3209 83.509 60.3209 84.707C60.3209 85.5855 59.9615 86.3841 58.5639 87.0231L57.2461 87.5821C53.8918 88.8999 53.0133 91.6153 53.0133 93.572C53.0133 95.8481 54.2512 96.6867 55.7287 96.6867C57.2861 96.6867 58.484 95.5686 58.6038 94.171C58.6837 93.1327 59.4025 92.6136 60.5605 92.2941C63.6752 91.3358 65.9115 88.6204 65.9115 84.7469C65.9115 79.955 62.4773 76.9601 57.4857 76.9601C53.6922 76.9601 50.857 78.797 49.659 81.9117Z",
    fill: "#006FBA"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 43.1013,
    y1: 120.352,
    x2: 82.8312,
    y2: 120.352,
    stroke: "#006FBA",
    strokeWidth: 4.63953,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.8634,
    cy: 120.259,
    r: 2.7064,
    fill: "#006FBA"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 43.0833,
    y1: 132.631,
    x2: 82.7384,
    y2: 132.631,
    stroke: "#006FBA",
    strokeWidth: 4.63953,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.8588,
    cy: 132.632,
    rx: 2.70183,
    ry: 2.7064,
    fill: "#006FBA"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 43.1011,
    y1: 145.002,
    x2: 82.831,
    y2: 145.003,
    stroke: "#006FBA",
    strokeWidth: 4.63953,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.8634,
    cy: 145.003,
    r: 2.7064,
    fill: "#006FBA"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconNeedsAssessment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-needs-assessment.66b85118.svg";
export { ForwardRef as ReactComponent };